<mat-toolbar color="success">
  <h2
    mat-dialog-title
    class="white-color"
  >
    Visualize — {{ data.patternName }}
  </h2>
</mat-toolbar>
<div
  mat-dialog-content
  class="fvl__content"
>
  <mat-form-field class="fvl__field yellow-input">
    <mat-label>Machine</mat-label>
    <mat-select
      [(ngModel)]="machineNumber"
      (ngModelChange)="filterToolings()"
    >
      @for (m of machines; track m.machineNumber) {
      <mat-option [value]="m.machineNumber">
        {{ m.machineNumber }} — {{ m.description }}
      </mat-option>
      }
    </mat-select>
    @if (machines.length === 0) {
    <mat-hint>No machines are licensed for shape punching</mat-hint>
    }
  </mat-form-field>

  <mat-form-field class="fvl__field yellow-input">
    <mat-label>Tooling code</mat-label>
    <input
      matInput
      [(ngModel)]="toolingCode"
      (ngModelChange)="filterToolings()"
      [matAutocomplete]="toolingAuto"
    />
    <mat-autocomplete
      #toolingAuto="matAutocomplete"
      (optionSelected)="defaultMachineFromTooling()"
    >
      @for (tool of filteredToolings; track tool.toolingCode) {
      <mat-option [value]="tool.toolingCode">
        {{ tool.toolingCode }}
        @if (tool.description) {
        <span class="fvl__mat-desc">— {{ tool.description }}</span>
        }
      </mat-option>
      }
    </mat-autocomplete>
    <mat-hint>{{ toolingHint }}</mat-hint>
  </mat-form-field>

  <mat-form-field class="fvl__field yellow-input">
    <mat-label>Material</mat-label>
    <input
      matInput
      [(ngModel)]="materialText"
      (ngModelChange)="filterMaterials()"
      [matAutocomplete]="materialAuto"
    />
    <mat-autocomplete #materialAuto="matAutocomplete">
      @for (mat of filteredMaterials; track mat.id) {
      <mat-option [value]="mat.materialCode">
        {{ mat.materialCode }}
        @if (mat.description) {
        <span class="fvl__mat-desc">— {{ mat.description }}</span>
        }
      </mat-option>
      }
    </mat-autocomplete>
    <mat-hint>{{ materialHint }}</mat-hint>
  </mat-form-field>

  <mat-form-field class="fvl__field yellow-input">
    <mat-label>Length</mat-label>
    <input
      matInput
      [(ngModel)]="lengthText"
      (keyup.enter)="visualize()"
    />
    <mat-hint>{{ lengthHint }}</mat-hint>
  </mat-form-field>
</div>
<div
  mat-dialog-actions
  [align]="'end'"
>
  <button
    mat-button
    (click)="close()"
  >
    Close
  </button>
  <button
    mat-button
    color="success"
    [disabled]="!canVisualize"
    (click)="visualize()"
  >
    Visualize
  </button>
</div>
